<div id="mainWrapper">

  <div class="flex items-center">
    @if (data.icon) {
      <div class="{{data.icon.iconClass}}">
        <mat-icon svgIcon="{{data.icon.name}}"></mat-icon>
      </div>
    }
    <div id="title">{{ data.title }}</div>
  </div>
  @if (data.text) {
    <p id="text">
      @for (textPart of data.text.split('{link}'); track textPart; let i = $index) {
        <span>
          <span>{{ textPart }}</span>
          @if (getLinkAtIndex(i)) {
            <a
                href="{{getLinkAtIndex(i).url}}"
                target="_blank"
                rel="noopener noreferrer"
                tabindex="-1">{{ getLinkAtIndex(i).linkText }}</a>
          }
        </span>
      }
    </p>
  }

  <div id="buttonContainer">
    <button matButton="outlined"
            id="cancelButton"
            [mat-dialog-close]="false"
            tabindex="-1">{{ data.cancelButtonText }}
    </button>
    <button mat-flat-button
            [ngClass]="{'bg-red-50': data.confirmationDialogType === confirmationDialogType.WARNING}"
            id="submitButton"
            [mat-dialog-close]="true"
            tabindex="-1">{{ data.submitButtonText }}
    </button>
  </div>

</div>
